import { useQuery } from 'react-query';
import { getForm } from '~/services/origins/contentful';
import { getLogger } from '~/utils/logger';
import type { UseQueryResult } from 'react-query';
import type { FormSchema } from '~/shared/domain/models';

export type UseContentfulFormSchema = (id: string) => UseQueryResult<FormSchema>;

export const useContentfulFormSchema: UseContentfulFormSchema = (id) => {
  const response = useQuery(
    ['getContentfulFormSchema', id],
    async () => {
      const data = await getForm(id);
      return data;
    },
    {
      enabled: true,
      onSuccess: () => {
        getLogger().info('[useContentfulFormSchema] - getForm', { id });
      },
      onError: (error) => {
        getLogger().error('[useContentfulFormSchema] - getForm', error);
      },
    },
  );

  return response;
};
